import { render } from "./IPMain.vue?vue&type=template&id=adca78b4"
import script from "./IPMain.vue?vue&type=script&lang=js"
export * from "./IPMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__